<div class="outer-container" *ngIf="curriculumDataReceived"
[class.noClick]="assignCurrWait"
>

  <div 
  fxLayout="row" 
  fxLayoutAlign="space-between">


      <!-- <div class="sub-title">Ascend - Register Curriculum</div> -->

      <div class="reg-steps" *ngIf="isNewcomer">

      <app-consumer-curriculum-registration-steps
      [whichStep]="3"
      >
      </app-consumer-curriculum-registration-steps>

    </div>

  </div>

  <div 
  fxLayout="column" 
  fxLayoutAlign="space-between" 
  class="background-white pd-40 blue-border">
    
    <div fxLayout="column">

      <div fxLayout="row" class="wrap-data mt-15 font-size-32">
        <i class="fas fa-chalkboard"></i>
        &nbsp;&nbsp;{{ selectedCurriculumData?.CurriculumName }}
      </div>

      <div fxLayout="row" class="wrap-data mt-15 font-size-22 indent-20">
        {{ selectedCurriculumData?.CurriculumDesc }}
      </div>

      <div fxLayout="row" fxLayoutAlign="space-around" class="mt-30">
        <img src="{{imagePath}}{{selectedCurriculumData.ImagePath}}" style="max-height: 150px;" alt="Curriculum" class="img" />

        <div class="right-side"
        fxLayout="column">

          <!-- <div> -->
            <!-- <div class="select-student-text" *ngIf="selectedStudentID <= 0">
              Select or add a student
            </div> -->

            <div fxLayout="row wrap" class="full-width" fxLayout="space-around center"
            [class.select-student]="selectedStudentID <= 0">

              <div>
                <mat-form-field 
                  class="full-width-half"
                  [class.selected]="selectedStudentID > 0">
                  <mat-select
                    [(ngModel)]="selectedStudent"
                    name="student"
                    (selectionChange)="changeStudentSelection(selectedStudent)"
                    [placeholder]="studentList.length > 0 ? 'Select Student' : 'No students available'"
                  >
                    <mat-option *ngFor="let student of studentList" [value]="student">
                      {{ student?.StudentFirstName }}&nbsp;{{
                        student?.StudentLastName
                      }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>

              
              <div>
                <button 
                class="button primary-button add-student"
                (click)="addNewStudent()">
                  + Add Student
                </button>
              </div>

            </div>

          <!-- </div> -->
          
          <div *ngIf="hasNoRecord">
            <div class="mt-15">
  
              <div class="select-level-text" *ngIf="selectedStudentID > 0 && selectedCurriculumProductLevelID == null">
                Next select a product level
              </div>
  
              <div   
                [class.select-level]="selectedStudentID > 0 && selectedCurriculumProductLevelID == null"
                >
  
                <app-product-level-picker 
                [curriculumID]="curriculumID"
                [jargon]="jargon"
                [isNewcomer]="isNewcomer"
                [selectedStudentID]="selectedStudentID"
                [productLevelID]="selectedCurriculumProductLevelID" 
                (selectedProductLevel)="setSelectedProductLevel($event)"
                [hasUnitTests]="selectedCurriculumData.HasUnitTests"
                [lessonCount]="selectedCurriculumData.LessonCount">
                </app-product-level-picker>
  
              </div>
  
            </div>
  
            <div fxLayout="row"  fxLayoutAlign="center center" class="button-container">
            
              <button 
                class="primary-button button demoButton" 
                [disabled]="!selectedStudentID && selectedCurriculumProductLevelID >= 0"
                *ngIf="selectedCurriculumProductLevelID == 0" 
                type="button"              
                (click)="onButtonClickTakeDemo()">                
                Take Free {{jargon.DemoAllFirstLetterCaps}}            
              </button>
        
                  
              <button        
                class="primary-button button"        
                [disabled]="!(selectedStudentID > 0)  || !this.selectedCurriculumProductLevelID"
                *ngIf="selectedCurriculumProductLevelID != 0"        
                type="button"        
                (click)="AssignCurriculum()">        
                Assign Curriculum        
              </button>
        
            </div>
          </div>
    
          <div *ngIf="hasDemoUnfinished" fxLayout="column" fxLayoutAlign="space-around center">
            <div>
              There is already a record for this student and curriculum. 
            </div>
            <button class="primary-button button action"  (click)="onButtonClickTakeDemo()"
            >Complete Diagnostic Exam <br>As Student</button>
          </div>
          
          <div *ngIf="hasDemoFinished" fxLayout="column" fxLayoutAlign="space-around center">
            <div>
              This student has already completed the free diagnostic exam. 
            </div>
            <button class="primary-button  button action" (click)="viewDiagResults()"
            >View Diagnostic Results</button>
          </div>

          <div *ngIf="hasPaidRecord" fxLayout="column" fxLayoutAlign="space-around center">
            <div>
              This student already has a paid.
            </div>
            <button class="primary-button button action" (click)="navigateExistingCurriculum()"
            >Go to Student Curriculum</button>
          </div>

        </div>
      </div>

     

     

    </div>
  </div>

</div>


  <div *ngIf="!curriculumDataReceived || assignCurrWait" class="spinner-wrapper">
    <mat-spinner [diameter]="50" mode="indeterminate"></mat-spinner>
  </div>
